import styled, { css } from 'styled-components'

import { Container, BlockHeader } from '../../styles/defaults'
import { maxmedia, minmedia } from '../../styles/media-queries'
import { white, bordergray } from '../../styles/colors'

export const Box = Container.extend`
  ${maxmedia.large`
    max-width: 100%;
  `}
  ${minmedia.large`
    border-top: 1px solid ${bordergray};
    padding-top: 2rem;
    margin-top: 4rem;
  `}
`

export const BoxHeader = BlockHeader.extend`
  ${maxmedia.large`
    cursor: pointer;
    background: ${white};
  `}
  ${minmedia.large`
    padding: 0; //reset
    border-bottom: 0; //reset
    margin-bottom: 3rem;

    & > div:last-child {
      display: none; // hide plusminus
    }
  `}
`

export const BoxContent = styled.div`
  transition: max-height .5s;

  ${maxmedia.large`
    max-height: 0;
    overflow: hidden;
    background: ${white};

    ${props => props.active && css`
      max-height: 999px;
      border-bottom: 1px solid ${bordergray};
    `}
  `}
`

export const BoxContentInner = styled.div`
  ${maxmedia.large`
    padding: 1rem;
  `}
`


// WEBPACK FOOTER //
// ./src/components/MobileToggler/styles.js